import { render, staticRenderFns } from "./savedModal.vue?vue&type=template&id=0a197718&scoped=true&"
import script from "./savedModal.vue?vue&type=script&lang=js&"
export * from "./savedModal.vue?vue&type=script&lang=js&"
import style0 from "./savedModal.vue?vue&type=style&index=0&id=0a197718&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a197718",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tsunagaru-v3-app-mintenant/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a197718')) {
      api.createRecord('0a197718', component.options)
    } else {
      api.reload('0a197718', component.options)
    }
    module.hot.accept("./savedModal.vue?vue&type=template&id=0a197718&scoped=true&", function () {
      api.rerender('0a197718', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/src/shared/components/modal/savedModal.vue"
export default component.exports